import { useState } from "react";
import { ReactComponent as HelpIcon } from "../../../assets/img/icon/help_black_24dpt.svg";
import { FAQS } from "../../../data/faq";
import CollapsedBox from "../../ui/atoms/CollapsedBox/ColllapsedBox";
import PageTitle from "../../ui/atoms/PageTitle/PageTitle";

const subMenu = [
  { label: "Pasien", path: "patient" },
  { label: "Rekam", path: "record" },
  { label: "Perangkat", path: "device" },
  { label: "Profil", path: "profile" },
];

const FaqPage = () => {
  const [page, setPage] = useState("patient");

  return (
    <>
      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman FAQ"
          description="Berikut adalah beberapa pertanyaan yang sering muncul untuk menggunakan aplikasi ini"
          icon={
            <HelpIcon className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />
        <div className="mt-12 md:mt-16">
          <div className="flex mb-5">
            {subMenu.map((menu) => (
              <div
                key={"submenu" + menu.label}
                className={
                  "bg-primary text-white px-2 py-1 " +
                  (menu.path === page
                    ? "bg-opacity-100"
                    : "bg-opacity-50 text-opacity-80 cursor-pointer hover:bg-opacity-80")
                }
                onClick={() => setPage(menu.path)}
              >
                {menu.label}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-12 gap-3 md:gap-4">
            {FAQS[page].length === 0 ? (
              <div className="col-span-12">
                Nampaknya kami belum memiliki informasi tentang ini.
              </div>
            ) : (
              FAQS[page].map((faq, idx) => (
                <div className="col-span-12 lg:col-span-6" key={faq.title}>
                  <CollapsedBox title={faq.title}>{faq.solution}</CollapsedBox>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqPage;
